import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  PdfSignOtpParams,
  PdfSignParams,
  PdfSignProvider,
  PdfSignResult,
  PdfSignStrategy,
  PdfSignUploadParams,
} from './pdf-sign.strategy';

/**
 * Proveedor "platform": API nueva de documentos
 * (ServidorDocumentos -> tfnbx-platform /documents/).
 */
@Injectable({ providedIn: 'root' })
export class PlatformPdfSignStrategy implements PdfSignStrategy {
  readonly provider: PdfSignProvider = 'platform';

  private serverDocuments = '';
  private documentBlob = '';

  constructor(private http: HttpClient) {}

  setEnviroments(enviroment: any): void {
    this.serverDocuments = enviroment?.ServidorDocumentos || '';
    this.documentBlob = enviroment?.DocumentBlob || '';
  }

  private buildUrl(path: string): string {
    const base = (this.serverDocuments || '').replace(/\/+$/, '');
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }

  getBlobDocument(path: string, signedDocument?: any): Observable<Blob> {
    const blobBase = (this.documentBlob || '').replace(/\/+$/, '');
    const sourceUrl =
      signedDocument?.sPath || `${blobBase}/${path.replace(/^\/+/, '')}`;

    return this.http.get(sourceUrl, { responseType: 'blob' });
  }

  getDococumentSign(idkatios: string, params: PdfSignParams): Observable<any> {
    const path = `sign/${idkatios}/${params.typeDocument}/${params.idDocument}/${params.tdoc}/${params.ndoc}`;
    return this.http
      .get<any>(this.buildUrl(path))
      .pipe(map((response: any) => response?.data));
  }

  sendCodeOTP(idkatios: string, params: PdfSignOtpParams): Observable<any> {
    const path = `sign/otp/${idkatios}/${params.typeDocument}/${params.idDocument}/${params.tdoc}/${params.ndoc}`;
    return this.http.post(this.buildUrl(path), params.data);
  }

  verifyCodeOTP(
    idkatios: string,
    params: PdfSignOtpParams,
  ): Observable<PdfSignResult> {
    const path = `sign/otp/validate/${idkatios}/${params.typeDocument}/${params.idDocument}/${params.tdoc}/${params.ndoc}`;

    return this.http.post<any>(this.buildUrl(path), params.data).pipe(
      map((response: any) => {
        if (response && typeof response === 'object' && 'Codigo' in response) {
          return response;
        }

        return {
          ...response,
          Codigo: String(response?.data?.codigo ?? '-1'),
          Descripcion:
            response?.data?.descripcion ||
            response?.message ||
            'No fue posible validar OTP',
          Token: response?.data?.token,
          Validado: !!response?.data?.validado,
          FirmasPendientes: response?.data?.firmasPendientes,
        };
      }),
    );
  }

  uploadSignedDocument(
    idkatios: string,
    params: PdfSignUploadParams,
  ): Observable<PdfSignResult> {
    const path = `sign/upload/${idkatios}/${params.typeDocument}/${params.idDocument}/${params.tdoc}/${params.ndoc}`;
    const formData = new FormData();
    formData.append('file', params.file, params.file.name);

    return this.http.post<any>(this.buildUrl(path), formData).pipe(
      map((response: any) => {
        if (response && typeof response === 'object' && 'Codigo' in response) {
          return response;
        }

        return {
          ...response,
          Codigo: String(
            response?.data?.Codigo ?? response?.data?.codigo ?? '-1',
          ),
          Descripcion:
            response?.data?.Descripcion ||
            response?.data?.descripcion ||
            response?.message ||
            'No fue posible cargar el documento',
          Token: response?.data?.Token ?? response?.data?.token,
          Validado: !!(response?.data?.Validado ?? response?.data?.validado),
          FirmasPendientes:
            response?.data?.FirmasPendientes ??
            response?.data?.firmasPendientes,
        };
      }),
    );
  }
}
